<template>
  <div
    v-if="reactionConfig.componentName"
    class="mb-24"
  >
    <component
      :is="reactionConfig.componentName"
      :reaction="reactionConfig"
    />
  </div>
</template>

<script>
import { DateTime } from 'luxon'

import formatDateToRelative from '@common/utils/formatDateToRelative'

import XBroadcastReaction from '@plat/views/event/reactions/BroadcastReaction'
import XImageReaction from '@plat/views/event/reactions/ImageReaction'
import XGifReaction from '@plat/views/event/reactions/GifReaction'
import XVideoReaction from '@plat/views/event/reactions/VideoReaction'

export default {
  components: {
    XBroadcastReaction,
    XImageReaction,
    XGifReaction,
    XVideoReaction
  },

  props: {
    reaction: {
      type: Object
    }
  },

  computed: {
    reactionConfig () {
      const date = DateTime.fromISO(this.reaction.createdAt)

      return {
        ...this.reaction,
        componentName: this.getComponentFromType(this.reaction.type),
        createdAt: this.$tc(
          'common.dates.' + formatDateToRelative(date).unit,
          formatDateToRelative(date).diff,
          { unit: formatDateToRelative(date).diff }
        )
      }
    }
  },

  methods: {
    getComponentFromType (reactionType) {
      switch (reactionType) {
        case 'photoOverlay':
          return 'XImageReaction'

        case 'photoChromaKey':
          return 'XImageReaction'

        case 'photoSelfie':
          return 'XImageReaction'

        case 'photoRaw':
          return 'XImageReaction'

        case 'chromaSelfie':
          return 'XImageReaction'

        case 'videoRaw':
          return 'XVideoReaction'

        case 'videoUrl':
          return 'XVideoReaction'

        case 'gif':
          return 'XGifReaction'

        case 'broadcast':
          return 'XBroadcastReaction'

        default:
          return null
      }
    }
  }
}
</script>
